module.exports = __webpack_public_path__ + "img/CATEGORY ICON-23.dd685920.png";